import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar } = FiIcons;

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Sarah M.',
      age: 34,
      location: 'San Francisco, CA',
      profile: 'Working mother of 2',
      quote: 'As a single mom, I needed affordable life insurance to protect my kids. The 20-year term policy gives me peace of mind knowing they\'ll be taken care of if something happens to me.',
      product: 'Term Life Insurance',
      coverage: '$500,000',
      rating: 5
    },
    {
      name: 'Michael R.',
      age: 45,
      location: 'Los Angeles, CA',
      profile: 'Business executive',
      quote: 'I needed substantial coverage for estate planning. The million-dollar policy process was surprisingly simple, and I got approved without a medical exam.',
      product: 'Million Dollar Coverage',
      coverage: '$2,000,000',
      rating: 5
    },
    {
      name: 'Elena G.',
      age: 72,
      location: 'San Diego, CA',
      profile: 'Retired grandmother',
      quote: 'I thought I was too old for life insurance, but the guaranteed approval whole life policy was perfect. Now my grandchildren will have something to help with college.',
      product: 'Whole Life Insurance',
      coverage: '$25,000',
      rating: 5
    },
    {
      name: 'David L.',
      age: 29,
      location: 'Sacramento, CA',
      profile: 'New homeowner',
      quote: 'Just bought our first house and needed to protect the mortgage. The online application took 5 minutes, and I was approved instantly. Couldn\'t be easier!',
      product: 'Term Life Insurance',
      coverage: '$750,000',
      rating: 5
    },
    {
      name: 'Maria S.',
      age: 38,
      location: 'Oakland, CA',
      profile: 'Small business owner',
      quote: 'Running my own business means unpredictable income. The no medical exam policy let me get coverage quickly without the hassle of appointments and tests.',
      product: 'No Medical Exam Insurance',
      coverage: '$300,000',
      rating: 5
    },
    {
      name: 'Robert K.',
      age: 67,
      location: 'Fresno, CA',
      profile: 'Recent retiree',
      quote: 'My wife and I wanted to ensure our final expenses wouldn\'t burden our children. The final expense policy was affordable and gave us the peace of mind we needed.',
      product: 'Final Expense Insurance',
      coverage: '$15,000',
      rating: 5
    },
    {
      name: 'Jennifer T.',
      age: 31,
      location: 'San Jose, CA',
      profile: 'Tech professional',
      quote: 'Working in tech, I appreciate efficiency. The entire process was digital, fast, and transparent. Got my policy the same day I applied.',
      product: 'Term Life Insurance',
      coverage: '$1,000,000',
      rating: 5
    },
    {
      name: 'Carlos M.',
      age: 52,
      location: 'Long Beach, CA',
      profile: 'Father of special needs child',
      quote: 'My daughter will need care for life. The 30-year term policy ensures she\'ll be financially protected even after I\'m gone. This gives our family incredible peace of mind.',
      product: 'Term Life Insurance',
      coverage: '$1,500,000',
      rating: 5
    },
    {
      name: 'Linda W.',
      age: 41,
      location: 'Riverside, CA',
      profile: 'Divorced mother',
      quote: 'After my divorce, I realized I had no life insurance. The application was so simple, and knowing my ex-husband can\'t contest this policy gives me security.',
      product: 'Term Life Insurance',
      coverage: '$400,000',
      rating: 5
    }
  ];

  return (
    <section className="py-16 bg-secondary-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-secondary-900 mb-4">
            Real Stories from Real California Families
          </h2>
          <p className="text-lg text-secondary-600 max-w-3xl mx-auto">
            See how life insurance has provided peace of mind and financial security for families across California.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow"
            >
              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <SafeIcon key={i} icon={FiStar} className="h-4 w-4 text-yellow-400 fill-current" />
                ))}
              </div>
              <blockquote className="text-secondary-700 mb-4 italic">
                "{testimonial.quote}"
              </blockquote>
              <div className="border-t border-secondary-200 pt-4">
                <div className="flex justify-between items-start mb-2">
                  <div>
                    <p className="font-semibold text-secondary-900">{testimonial.name}</p>
                    <p className="text-sm text-secondary-600">{testimonial.profile}</p>
                    <p className="text-sm text-secondary-500">{testimonial.location}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm font-medium text-primary-600">{testimonial.product}</p>
                    <p className="text-sm text-secondary-600">{testimonial.coverage}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <a 
            href="https://quote.burbankinsuranceservices.com/Dt2tCn" 
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-3 bg-primary-600 text-white font-semibold rounded-lg hover:bg-primary-700 transition-colors shadow-lg"
          >
            Start Your Application Today
          </a>
          <p className="mt-2 text-sm text-secondary-500">
            Join thousands of satisfied California families
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default TestimonialsSection;